<template>
  <div>
    <!-- Coordinateur -->
    <div class="home" v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
      <section class="main">
        <img src="/static/img/home-background.jpg" class="main__background">
        <div class="main__content">
          <div class="main__search search-container">
            <h2 class="search-container__title">Quel produit recherchez-vous ?</h2>
            <input type="text" name="" placeholder="Rechercher un produit" value="" v-model="searched" @keyup="search(searched)" class="search-container__field" ref="keyword">
            <a href="" class="reset-search" v-show="this.$refs.keyword && this.$refs.keyword.value != ''"><img src="/static/img/pictos/fermer-bleu.svg" @click.prevent="resetSearch()"></a>
            <SearchResultsHome v-if="searched" :loading="loading" :searched="searched"></SearchResultsHome>
          </div>
          <div class="main__actions">
            <router-link
              :to="{name: 'OrderList'}"
              class="action action--orders"
            >
              <img class="action__picto" src="/static/img/pictos/commande.svg" alt="">
              <span class="action__text">Mes commandes</span>
              <span class="action__btn"><img src="/static/img/pictos/flechebleuciel.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'HomeTechs'}"
              class="action action--techs"
            >
              <img class="action__picto" src="/static/img/pictos/technicien.svg" alt="">
              <span class="action__text">Mes techniciens</span>
              <span class="action__btn"><img src="/static/img/pictos/flechemarine.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'ProductFavoritesList'}"
              class="action action--products"
            >
              <img class="action__picto" src="/static/img/pictos/produit-favoris.svg" alt="">
              <span class="action__text">Mes produits favoris</span>
              <span class="action__btn"><img src="/static/img/pictos/flecheverte.svg" alt=""></span>
            </router-link>
          </div>
        </div>
      </section>
      <section class="content home__products products">
        <!-- <h2 class="title">Découvrez les nouveautés</h2> -->
        <div class="products__list">
          <ProductList></ProductList>
        </div>
      </section>
    </div>

    <!-- TECHs -->
    <div class="home home--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
        <div class="main__search search-container">
          <h2 class="search-container__title">Quel produit recherchez-vous ?</h2>
          <input type="text" name="" placeholder="Rechercher" value="" v-model="searched" @keyup="search(searched)" class="search-container__field" ref="keyword">
          <a href="" class="reset-search" v-show="this.$refs.keyword && this.$refs.keyword.value != ''"><img src="/static/img/pictos/fermer-bleu.svg" @click.prevent="resetSearch()"></a>
          <SearchResultsHome v-if="searched" :loading="loading" :searched="searched" class="mobile"></SearchResultsHome>
        </div>
        <ProductFamilyList></ProductFamilyList>
        <div class="main__actions">
          <router-link
          :to="{name: 'Stock'}"
          class="action action--stock"
          >
            <span class="action__text">Mon stock</span>
            <div class="action__picto">
              <span class="nb" v-if="stock && stock > 0">{{ stock }}</span>
              <img class="" src="/static/img/pictos/stockcamion.svg" alt="">
            </div>
            <span class="action__btn"><img src="/static/img/pictos/flechevertjaune.svg" alt=""></span>
          </router-link>
          <router-link
            :to="{name: 'ReapproList'}"
            class="action action--reappro"
          >
            <span class="action__text">Mes réappros</span>
            <div class="action__picto">
              <span class="nb" v-if="reappros && reappros > 0">{{ reappros }}</span>
              <img class="" src="/static/img/pictos/reappro.svg" alt="">
            </div>
            <span class="action__btn"><img src="/static/img/pictos/flechemarine.svg" alt=""></span>
          </router-link>
          <router-link
            :to="{name: 'OrderList'}"
            class="action action--orders"
          >
            <span class="action__text">Mes commandes</span>
            <div class="action__picto">
              <span class="nb" v-if="orders && orders > 0">{{ orders }}</span>
              <img class="" src="/static/img/pictos/commande.svg" alt="">
            </div>
            <span class="action__btn"><img src="/static/img/pictos/flechebleuciel.svg" alt=""></span>
          </router-link>
        </div>

        <ProductFavoritesSwiper></ProductFavoritesSwiper>

    </div>

    <!-- ADMIN -->
    <div class="home home--admin" v-if="$store.getters['auth/isRole']('ROLE_ADMIN') == true || $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') == true">
      <section class="main">
        <img src="/static/img/home-background.jpg" class="main__background">
        <div class="main__content">
          <div class="main__search search-container">
            <h2 class="search-container__title">Bienvenue {{ user.firstname }}</h2>
          </div>
          <div class="main__actions">
            <router-link
              :to="{name: 'AdminOrderList'}"
              class="action action--blue"
            >
              <img class="action__picto" src="/static/img/pictos/commande.svg" alt="">
              <span class="action__text">Commandes</span>
              <span class="action__btn"><img src="/static/img/pictos/flechemarine.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'AdminUserList'}"
              class="action action--lightblue"
            >
              <img class="action__picto" src="/static/img/pictos/technicien.svg" alt="">
              <span class="action__text">Utilisateurs</span>
              <span class="action__btn"><img src="/static/img/pictos/flechebleuciel.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'AdminProductList'}"
              class="action action--blue"
            >
              <img class="action__picto" src="/static/img/pictos/picto-produit.svg" alt="">
              <span class="action__text">Produits</span>
              <span class="action__btn"><img src="/static/img/pictos/flechemarine.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'AdminVehicleList'}"
              class="action action--lightblue"
            >
              <img class="action__picto" src="/static/img/pictos/stockcamion.svg" alt="">
              <span class="action__text">Véhicules</span>
              <span class="action__btn"><img src="/static/img/pictos/flechebleuciel.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'AdminAgencyList'}"
              class="action action--lightblue"
            >
              <img class="action__picto" src="/static/img/pictos/agencerond.svg" alt="">
              <span class="action__text">Agences</span>
              <span class="action__btn"><img src="/static/img/pictos/flechebleuciel.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'AdminProductFamilyList'}"
              class="action action--blue"
            >
              <img class="action__picto" src="/static/img/pictos/vis.svg" alt="">
              <span class="action__text">Familles de produits</span>
              <span class="action__btn"><img src="/static/img/pictos/flechemarine.svg" alt=""></span>
            </router-link>
            <router-link
              :to="{name: 'AdminGroupList'}"
              class="action action--lightblue"
            >
              <img class="action__picto" src="/static/img/pictos/technicien.svg" alt="">
              <span class="action__text">Groupes</span>
              <span class="action__btn"><img src="/static/img/pictos/flechebleuciel.svg" alt=""></span>
            </router-link>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
  import ProductList from "@/components/Product/ProductList";
  import ProductFavoritesSwiper from "@/components/Product/ProductFavoritesSwiper";
  import SearchResults from "@/components/Global/SearchResults";
  import SearchResultsHome from "@/components/Global/SearchResultsHome";

  export default {
    name: 'Home',
    data() {
      return {
        version: process.env.VERSION,
        currentRoute: window.location.pathname,
        showLoader: false,
        searched: "",
        loading: 0,
        items: [],
        myFavorites: [],
        myFavoritesIds: [],
        orders: 0,
        stock: 0,
        reappros: 0,
      };
    },
    mounted(){
      if (!this.items || !this.items.length) {
        this.isBusy = true;
      }
      const self = this;
      this.$store.dispatch('showLoader');
      this.$store.dispatch("product/getAllCurrent").then(() => {
        self.getItems();
        if(this.$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true){
          this.$store.dispatch("order/getMyOrdersCount").then(() => {
            self.getOrders();
            this.$store.dispatch("vehicle/getMyVehicleStockCount").then(() => {
              self.getMyStock();
              this.$store.dispatch("order/getMyReapprosCount").then(() => {
                self.getMyReappros();
                this.$store.dispatch('hideLoader');
                //
              });
            });
          });
        }else{
          this.$store.dispatch("order/getMyOrdersCount").then(() => {
            self.getOrders();
            this.$store.dispatch("agency/getAll").then(() => {
              this.$store.dispatch("vehicle/getAll").then(() => {
                this.$store.dispatch("group/getAll").then(() => {
                  this.$store.dispatch('hideLoader');
                });
              });
            });
          });
        }
      });
    },
    created() {
      this.$store.dispatch('showLoader');
    },
    computed: {
      // Récupération de mes infos personnelles
      user: function() {
        let user = this.$store.getters['auth/user'];

        // Cas ou le retour était en LocalStorage et sous la forme d'un json "stringifié" : on le retransforme en objet JS.
        if(typeof(user) == 'string'){
          return JSON.parse(user);
        }else{
          return user;
        }
      },
    },
    components: {
      ProductFamilyList,
      ProductList,
      ProductFavoritesSwiper,
      SearchResults,
      SearchResultsHome
    },
    methods:{
      getItems(){
        const self = this;
        self.items = this.$store.getters["product/getAllCurrent"];
      },
      getMyFavorites(){
        const self = this;
        self.myFavoritesIds = this.$store.getters["auth/myFavoritesProducts"];
        self.myFavorites = self.items.filter(i => self.myFavoritesIds.includes(i.id))
      },
      getOrders(){
        const self = this;
        self.orders = this.$store.getters["order/getMyOrdersCount"];
      },
      getMyStock(){
        const self = this;
        self.stock = this.$store.getters["vehicle/getMyVehicleStockCount"];
      },
      getMyReappros(callback){
        const self = this;
        self.reappros = this.$store.getters["order/getMyReapprosCount"];
        this.$nextTick(function () {
          //this.$store.dispatch('hideLoader');
        })
      },
      // Vide le champ de recherche
      resetSearch(){
        const self = this;
        this.$store.dispatch('search/setResults', null).then(function(){
          self.$refs.keyword.value = '';
          self.searched = "";
        });
      },
      search(searched){
        if(searched != ''){
          this.$store.dispatch('showHomeSearch');
        }else{
          this.$store.dispatch('hideHomeSearch');
        }

        if(this.loading == 0){
          this.loading = 1;
          this.$http.post('product/search', {
            predicate: searched,
          }).then(response => {
            this.$store.dispatch('search/setResults', response.data);
            this.loading = 0;
          }).catch(error => {
            this.loading = 0;
          })
        }else{

        }
      },
    },
    render(h) {
      return h(this.ViewComponent);
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  section.main{ display: flex; flex-wrap: wrap; width: 100%; align-items: center; height: calc(100vh - 215px); position: relative;
    &--admin{ top: 75px; height: calc(100vh - 75px);

    }
  }
  .main__background{ object-fit: cover; height: 100%; width: 100%; }
  .main__content{ height: 100%; position: absolute; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;
    .search-container{ width: 50%; position: relative;
      &__title{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; text-align: center; }
      &__field{ width: 100%; border: none; height: 45px; line-height: 45px; border-radius: 15px; outline: none; padding: 0 20px; font-size: 12px; }
    }
    .reset-search{ position: absolute; top: 42px; right: 20px;
      img{ width: 10px; }
    }
  }
  .main__actions{ display: flex; width: 50%; flex-direction: row; flex-wrap: wrap; margin-top: 45px;
    .action{ text-align: center; color: white; display: flex; flex-direction: column; align-items: center; justify-content: flex-end; position: relative;
      &--orders, &--techs{ width: calc(50% - 5px); height: calc((100vh - 215px) / 3); justify-content: center; min-height: 220px;
        .action__btn{ position: absolute; bottom: 0; }
      }
      &--orders{ background-color: $color3; margin-right: 10px; }
      &--techs, &--blue{ background-color: $color4; }
      &--lightblue{ background-color: $color3; }
      &--green{ background-color: $vert; }
      &__picto{ width: 30%; }
      &__text{ font-family: 'ClanFFBlack'; font-size: 15px; text-transform: uppercase; margin-top: 5%; }
      &__btn{ width: 80px; height: 40px; background-color: white; align-self: flex-end; margin-top: 5%; line-height: 36px;
        img{ width: 16px; }
      }
      &--products{ width: 100%; background-color: $vert; height: calc((100vh - 215px) / 9); margin-top: 10px; flex-direction: row; justify-content: flex-start;
        .action__picto{ height: 45px; width: 45px; margin: 0 5%; }
        .action__text{ margin-top: 0; flex: 1; text-align: left; }
      }
      &:hover{ text-decoration: none; }
    }
  }
  .products{ width: 100%;
    .title{ margin-left: 5%; }
  }
  .home{
    &__products{ width: 100% !important; }
    &--mobile{ padding-top: 75px;
      .main{ height: auto;
        .categories{ width: 100%; }
      }
      .search-container{ width: 100%; margin-top: 60px; text-align: center;
        &__title{ color: $color2; text-align: center; margin-bottom: 15px; display: block; font-size: 18px; }
        &__field{ width: 90%;  border: 1px solid $color1; font-family: 'ClanPro'; font-size: 12px; color: $color1; padding-right: 40px; }
      }
      .main__actions{ display: flex; width: 100%; flex-direction: column; flex-wrap: wrap; margin-top: 0; padding: 20px;
        .action{ width: 100%; margin: 0; margin-bottom: 4px; height: 125px; display: flex; width: 100%; flex-direction: row; min-height: 0;
          &--reappro{ background-color: $color4; }
          &--stock{ background-color: $vertjaune; }
          &--orders{ background-color: $color3; }
          .action__btn{ left: 24px; right: auto; position: absolute; margin-top: 0; bottom: 0; }
          .action__picto{ width: 180px; position: relative;
            img{ width: 100px; }
            .nb{ width: 35px; height: 35px; line-height: 35px; background: $rouge; border-radius: 50%; display: block; position: absolute; left: 100px; top: -5px; font-family: 'ClanFFBlack'; color: white; font-size: 14px; }
          }
          .action__text{ width: calc(100% - 180px); color: white; font-family: 'ClanFFBlack'; text-align: left; margin-top: 40px; margin-left: 24px; align-self: flex-start; }
        }
      }
      .reset-search{ position: absolute; top: 45px; right: calc(5% + 20px);
        img{ width: 10px; }
      }
    }
    &--admin{
      .main{ height: calc(100vh - 100px);  }
      .main__content{  }
      .main__actions{ width: 75%;
        .action{ width: calc((100% - 120px) / 4); margin-right: 40px; height: calc((100vh - 215px) / 3); justify-content: center; min-height: 220px;
          .action__btn{ position: absolute; bottom: 0; }
          &:nth-of-type(1){ margin-bottom: 40px; }
          &:nth-of-type(2){ margin-bottom: 40px; }
          &:nth-of-type(3){ margin-bottom: 40px; }
          &:nth-of-type(4){ margin-bottom: 40px; }
          &:nth-of-type(4n){ margin-right: 0;

          }
        }
      }
    }
  }
  .content{ width: 90%; margin: 0 auto;  }
  .title{ margin-top: 100px; margin-bottom: 50px; color: $color2; font-family: 'ClanFFBlack'; font-size: 25px; }

  @media screen and (max-width: 500px){
    .home{
      &--mobile{
        .main__actions{
          .action{
            .action__picto{ width: 100px; position: relative; margin-right: 20px;
              img{ width: 70px; }
              .nb{ width: 35px; height: 35px; line-height: 35px; background: $rouge; border-radius: 50%; display: block; position: absolute; left: 60px; top: -5px; font-family: 'ClanFFBlack'; color: white; font-size: 14px; }
            }
            .action__text{ width: calc(100% - 100px); }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue